import React from "react"
import { registerService } from "./model/service";
import ERegister from "./view/_register";

function EsignUpVerification ({handlecancel}){
    const verifySignUp=(data)=>{
       return  registerService.register(data)
           
    }
return(<>{
    <ERegister verifySignUp={verifySignUp} handlecancel={handlecancel} ></ERegister>
}
</>)
}
export default EsignUpVerification